// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2OWkP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2-91t","obliqueLine":"membershipbadge_obliqueLine__1vbMK"};